import TriggerSerializer from 'eflex/serializers/trigger';

export default class EdhrTriggerSerializer extends TriggerSerializer {
  constructor() {
    super(...arguments);
    this.attrs.edhrMappings = { embedded: 'always' };
  }
}
